<template>
  <sys-data-table
    :items="listas"
    :headers="cabecalhos"
    :height="alturaDaJanela - 200"
    :itemHeight="45"
    :item-height="50"
    :items-per-page="-1"
    class="elevation-1"
  >
    <template #item.qtd_produtos="{ value }">
      {{ Helpers.formatarValor(value) }}
    </template>

    <template #item.acoes="{ item }">
      <DialogListaProdutos :row="item" />
    </template>
  </sys-data-table>
</template>

<script>
import DialogListaProdutos from './DialogListaProdutos'
import responsiveHeight from '@/helpers/ResponsiveHeight.js';
import {buscarListaArquivosImportados} from '@/api/Parametrizacao/CurvaCriticidade'

export default {
  name: "Grid",
  mixins: [responsiveHeight],
  components: {
    DialogListaProdutos
  },
  props: ["atualizar_grid_count"],
  data: () => ({
    dialog_produtos: false,
    listas: [],
    produtos_lista: [],
    cabecalhos: [
      { text: 'Id', value: 'id' },
      { text: 'Nome Usuário', value: 'nome_usuario' },
      { text: 'Qtde. produtos', value: 'qtd_produtos' },
      { text: 'Data de importação', value: 'created_at' },
      { text: 'Ações', value: 'acoes', style: { width: '80px' } },
    ]
  }),
  watch: {
    atualizar_grid_count() {
      this.buscarListaDeImportacao()
    }
  },
  created() {
    this.buscarListaDeImportacao()
  },
  methods: {
    buscarListaDeImportacao() {
      this.$store.dispatch('loading/addRequisicao',
        buscarListaArquivosImportados().then(lista_produtos => this.listas = lista_produtos)
      )
    }
  }
}
</script>
